export const YOU_TUBE_URL_REGEX =
  /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|\?v=)([^#&?]*).*/;

export const YOU_TUBE_SHORT_URL_REGEX =
  /(?:https?:\/\/)?(?:www\.|m\.)?youtube\.com\/(?:shorts\/)([^#&?]*).*/;

export const TIKTOK_URL_REGEX =
  /(?:https?:\/\/)?(?:www\.|m\.|vm\.)?tiktok\.com\/(?:@[\w.-]+\/video\/(\d+)|v\/(\d+)|embed\/(\d+)|trending\?shareId=(\d+)|share\/user\/(\d+)|h5\/share\/usr\/(\d+)|(\w+))/;

export const INSTAGRAM_URL_REGEX =
  /(?:https?:\/\/)?(?:www\.)?instagram\.com\/(?:[^/]+\/)?(?:p|reel|reels|tv)\/([A-Za-z0-9_-]+)/;

export const DOUYIN_URL_REGEX =
  /(?:https?:\/\/)?(?:www\.|m\.)?douyin\.com\/(?:video\/(\d+)|v\/(\d+)\.html|embed\/(\d+)|share\/user\/(\d+)|h5\/share\/usr\/(\d+))|(?:https?:\/\/)?v\.douyin\.com\/([A-Za-z0-9]+)\/?|(?:https?:\/\/)?iesdouyin\.com\/share\/video\/(\d+)/;

export enum PlatformType {
  youtube = 'youtube',
  tiktok = 'tiktok',
  instagram = 'instagram',
  douyin = 'douyin',
}

export const isYoutubeUrl = (value?: string | null) =>
  YOU_TUBE_URL_REGEX.test(value) || YOU_TUBE_SHORT_URL_REGEX.test(value);

export const isYoutubeShortUrl = (value?: string | null) => YOU_TUBE_SHORT_URL_REGEX.test(value);

export const extractYoutubeId = (value?: string | null) => {
  if (!value) return null;
  if (isYoutubeUrl(value)) {
    const match = value.match(YOU_TUBE_URL_REGEX);
    if (match) return match[2];
    const matchShort = value.match(YOU_TUBE_SHORT_URL_REGEX);
    if (matchShort) return matchShort[1];
    return match[2];
  }
  return null;
};

export const isInstagramUrl = (value?: string | null) => INSTAGRAM_URL_REGEX.test(value);

export const extractInstagramId = (value?: string | null) => {
  if (!value) return null;
  const match = value.match(INSTAGRAM_URL_REGEX);
  return match?.[1];
};

export const isTikTokUrl = (value?: string | null) => TIKTOK_URL_REGEX.test(value);

export const extractTikTokId = (value?: string | null) => {
  if (!value) return null;
  const match = value.match(TIKTOK_URL_REGEX);
  for (let i = 1; i <= 7; i++) {
    if (match?.[i]) return match[i];
  }
  return null;
};

export const isDouyinUrl = (value?: string | null) => DOUYIN_URL_REGEX.test(value);

export const extractDouyinId = (value?: string | null) => {
  if (!value) return null;
  const match = value.match(DOUYIN_URL_REGEX);
  if (!match) return null;

  for (let i = 1; i <= 7; i++) {
    if (match?.[i]) return match[i];
  }

  return null;
};

export const getSocialPlatform = (value?: string | null) => {
  if (!value) return null;
  if (isYoutubeUrl(value)) {
    return PlatformType.youtube;
  }
  if (isTikTokUrl(value) || isDouyinUrl(value)) {
    return PlatformType.tiktok;
  }
  if (isInstagramUrl(value)) {
    return PlatformType.instagram;
  }
  return null;
};

export default {
  isYoutubeUrl,
  isTikTokUrl,
  isInstagramUrl,
  extractYoutubeId,
  extractTikTokId,
  extractInstagramId,
  getSocialPlatform,
};
